import {Loader} from '@googlemaps/js-api-loader';
import {MarkerClusterer, DefaultRenderer} from "@googlemaps/markerclusterer";

const Magyarsag = (function () {
    const source = 'Forrás: publikus keresőmotorok, intézményi weboldalak, nyílt adatbázisok (2022. Április)';

    const setUpListeners = () => {
        $('#search-btn').click(() => {
            search();
        })

        $('#organization').change((e) => {
            getCountryList(e.target.value)
        })

        let searchTimeout;

        $('#search').keyup((e) => {
            clearTimeout(searchTimeout);
            if (e.keyCode === 13) {
                search();
            } else if (e.target.value.length > 2 || e.target.value.length === 0) {
                searchTimeout = setTimeout(() => {
                    search();
                }, 500)
            }
        })
    }

    const infiniteScroll = () => {
        $(window).scroll(function () {
            if ($(document).height() - $(this).height() === $(this).scrollTop()) {
                $('.location-holder.hidden').filter((i) => {
                    return i < 50;
                }).removeClass('hidden');
            }
        });
    }

    const search = () => {
        let query = {
            search: $('#search').val(),
            organization: $('#organization').val(),
            country: $('#country').val(),
        }

        getLocations(query['search'], query['organization'], query['country']);

        let queryString = '?' + new URLSearchParams(query).toString();
        window.history.pushState({}, null, queryString)

        $('#map').addClass('hidden');
        $('#loader-screen').removeClass('hidden');
    }

    let locations = [];
    let allLocations = [];

    const getLocations = (search = null, organization = null, country = null) => {
        $.ajax({
            method: 'GET',
            url: '/magyarsag-api/getLocations',
            data: {
                search,
                organization,
                country
            },
            success: function (response) {
                getCountryList()
                processResults(response['data'], {'search': search, 'organization': organization,  'country':country});
                initMap();
                infiniteScroll();
            },
            error: function (error) {
                console.log(error);
            }
        })
    }

    const getCountryList = (query = null) => {
        $.ajax({
            method: 'GET',
            url: '/magyarsag-api/getCountryList',
            data: {
                query
            },
            success: response => {
                console.log(response);
                fillCountryList(response['data']);
            },
            error: function (error) {
                console.log(error);
            }
        })
    }

    const fillCountryList = (list) => {
        $('#country').find('option').remove();
        $('#country').append(`<option value="" selected>Minden ország</option>`);
        Object.keys(list).forEach(key => {
            $('#country').append(`<option value="${key}">${list[key]}</option>`);
        })
    }

    const processResults = (results, query) => {
        locations = [];
        let withoutCoordinates = []
        for (let item of results['formattedList']) {
            if (item.location.lat !== 0 && item.location.lng !== 0) {
                locations.push(item);
            } else {
                withoutCoordinates.push(item);
            }
        }
        console.log(withoutCoordinates);
        allLocations = results['formattedList'];
        if (query) {
            $('#loading').addClass('hidden');
            $('.results-container').html('');
        }
        let i = 0;
        for (let item of allLocations) {
            let visibility = i > 50 ? 'hidden' : '';

            let HTML = `<tr class="location-holder ${visibility}" data-id="${item.id}">
                            <td>${i + 1}</td>
                            <td><a class="location-link">${item.name}</a></td>
                            <td>${item.address ?? 'Nincs cím'}</td>
                            <td>${item.country ?? 'Nincs ország megadva'}</td>
                        </tr>`

            $('.results-container').append(HTML);
            i++;
        }
        $('#result-count').html(results['resultCount']);
    }

    const initMap = () => {
        const loader = new Loader({
            apiKey: GOOGLE_API_KEY,
            version: "weekly",
            libraries: ["places"]
        });

        const center = {lat: 47.49860514223591, lng: 19.037656466182387};

        const mapOptions = {
            center: center,
            zoom: 2,
            fullscreenControl: false,
            mapTypeControl: false,
            mapId: 'DEMO_MAP_ID'
        };

        loader
            .load()
            .then(async (google) => {
                const { Map, InfoWindow } = await google.maps.importLibrary("maps");

                let map = new Map(document.getElementById("map"), mapOptions);
                const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

                let infoWindow = new google.maps.InfoWindow({
                    content: "",
                    disableAutoPan: false,
                });

                let latlng = []

                const markers = locations.map((data, i) => {
                    const image = document.createElement("img");
                    image.src = SITE_URL + 'public/img/hungarian_pin.png';
                    image.className = 'drop'

                    const marker = new AdvancedMarkerElement({
                        position: data.location,
                        map,
                        content: image,
                        title: data.name
                    });

                    marker.content.style.opacity = "0";
                    marker.content.addEventListener("animationend", (event) => {
                        marker.content.classList.remove("drop");
                        marker.content.style.opacity = "1";
                    });

                    latlng.push(data.location)

                    let nameHTML = `<h5>${data.name}</h5>`

                    marker.addListener("click", () => {
                        infoWindow.setContent(nameHTML + ' <br> ' + replaceURLs(data.description) + '<br><br>' + source);
                        infoWindow.open(map, marker);
                    });

                    return marker;
                });

                let renderer = new DefaultRenderer()

                let markerCluster = new MarkerClusterer({map, markers, renderer})

                if (latlng.length > 0) {
                    let latLngBounds = new google.maps.LatLngBounds();
                    for (let latlngitem of latlng) {
                        latLngBounds.extend(latlngitem)
                    }

                    map.fitBounds(latLngBounds);
                }

                markerCluster.addListener("click", () => {
                    infoWindow.close();
                })

                $('.location-link').click((e) => {
                    infoWindow.close();
                    let id = $(e.target).closest('tr').data('id');
                    let hasLocation = false;
                    for (let item of locations) {
                        if (item.id === id) {
                            hasLocation = true;
                            map.setCenter(item.location);
                            map.setZoom(17);
                            $("html, body").animate({scrollTop: 0}, "slow");
                            for (let m of markers) {
                                let nameHTML = `<h5>${item.name}</h5>`
                                if (m.metadata.id === id) {
                                    infoWindow.setContent(nameHTML + ' <br> ' + replaceURLs(item.description) + '<br><br>' + source);
                                    infoWindow.open(map, m);
                                }
                            }
                        }
                    }
                    if (!hasLocation) {
                        for (let item of allLocations) {
                            if (item.id === id) {
                                $('#location-modal-label').html(item.name);
                                $('#location-modal-body').html(replaceURLs(item.description) + '<br><br>' + source);
                            }
                        }
                        $('#location-modal').modal();
                    }
                })

                $('#map').removeClass('hidden');
                $('#loader-screen').addClass('hidden');
            })
            .catch((e) => {
                console.log('------------')
                console.log(e);
            });
    }

    const getURLSearchParams = () => {
        let urlParams = new URLSearchParams(window.location.search);
        return {
            search: urlParams.get('search'),
            organization: urlParams.get('organization'),
            country: urlParams.get('country'),
        }
    }

    const initializeForm = (urlSearchParams) => {
        if (urlSearchParams.search || urlSearchParams.organization || urlSearchParams.country) {
            $('#organization option').filter((index, value) => {
                return $(value).val() === urlSearchParams.organization;
            }).prop('selected', true);
            $('#search').val(urlSearchParams.search);
            $('#country option').filter((index, value) => {
                return $(value).val() === urlSearchParams.country
            }).prop('selected', true)
        }
    }

    function replaceURLs(message) {
        if (!message) return;

        let urlRegex = /(((http(s)?:\/\/)|(www\.))[^\s]+)|[^\s]+@[^\s]+/g;
        return message.replace(urlRegex, function (url) {
            let hyperlink = url;
            if (hyperlink.match('^www\.')) {
                hyperlink = 'http://' + hyperlink;
            } else if (hyperlink.match('^[^\\s]+@[^\\s]+')) {
                hyperlink = 'mailto:' + hyperlink;
            }
            hyperlink = hyperlink.replace(',', '')
            return '<a href="' + hyperlink + '" target="_blank" rel="noopener noreferrer">' + url.replace(',', '') + '</a>'
        });
    }

    return {
        init: () => {
            let urlSearchParams = getURLSearchParams();
            getLocations(urlSearchParams['search'], urlSearchParams['organization'], urlSearchParams['country']);
            getCountryList();
            initializeForm(urlSearchParams);
            setUpListeners();
        }
    }
})()

export default Magyarsag;
